import {useMantineColorScheme} from "@mantine/core";
import {PublicLayout} from './PublicLayout.tsx';
import {UserLayout} from './UserLayout.tsx';
import {useUserAttributes} from "../hooks/useUserAttributes.ts";
import {useSearchParams} from "react-router-dom";
import {signInWithRedirect, signOut} from "aws-amplify/auth";

const handleSignIn = async () => {
    try {
        await signOut();
    } catch {
        // ignore — no active session
    }
    await signInWithRedirect();
};

export const ColorSchemeWrapper = ({children}: { children: React.ReactNode }) => {
    const {setColorScheme} = useMantineColorScheme();
    const handleColorScheme = (value: boolean) => setColorScheme(value ? 'dark' : 'light');
    console.debug("ColorSchemeWrapper", handleColorScheme)
    // useEffect(() => {
    //     channel.on(DARK_MODE_EVENT_NAME, handleColorScheme);
    //     return () => channel.off(DARK_MODE_EVENT_NAME, handleColorScheme);
    // }, [channel]);

    return <>{children}</>;
}


export const AppLayout = () => {

    const [searchParams] = useSearchParams();

    const next = searchParams.get('next');

    const {sub} = useUserAttributes()
    if (!sub) {

        if (next && next === 'authn') {
            handleSignIn()
        }

        return <PublicLayout/>
    } else {
        return (<UserLayout/>);
    }

};
